module.exports = __webpack_public_path__ + "img/minecart-loaded.7bc75d4d.svg";